import { HPPcode } from "./hashUtil";
import api from "./axiosInstance";

const getLanguageCount = (
  token,
  startDateStr,
  endDateStr,

  hexHash,
) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/languageCount`, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
        params: {
          // startDateStr: startDateStr,
          // endDateStr: endDateStr,
          startDateStr: "2026-04-30T23:59:59Z",
          endDateStr: "2026-06-31T23:59:59Z",
          HPPcode: hexHash,
        },
      })
      .then((data, err) => {
        if (data) {
          resolve(data);
        } else {
          resolve("error");
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getLanguageCount;
//
